class ChallengeModel {
	id = null;
	title = '';
	challengeType = {};
	status = '';
	award = {
		amount: '',
		currencyCode: 'EUR',
	};
	deadline = '';
	solutionStats = null;
	type = null;
	backgroundImg = null;
	description = '';
	details = '';
	editableByCurrentSeeker = false;
	expectedSolutions = '';
	minimumRequirements = [];
	video = '';
	attachments = [];
	challengeAreas = [];
	submittedDate = '';
	translations = [];
	isExternal = false;
	externalLink = '';
	externalLogo = null;


	constructor({
		id = null,
		title = '',
		challengeType = {},
		status = '',
		award = {
			amount: '',
			currencyCode: 'EUR',
		},
		deadline = '',
		solutionStats = null,
		type = null,
		backgroundImg = null,
		description = '',
		details = '',
		editableByCurrentSeeker = false,
		expectedSolutions = '',
		minimumRequirements = [],
		video = '',
		attachments = [],
		challengeAreas = [],
		submittedDate = '',
		translations = [],
		isExternal = false,
		externalLink = '',
		externalLogo = null,

	}) {
		this.id = id;
		this.title = title;
		this.challengeType = challengeType;
		this.status = status;
		this.award = award;
		this.deadline = deadline;
		this.solutionStats = solutionStats;
		this.type = type;
		this.backgroundImg = backgroundImg;
		this.description = description;
		this.details = details;
		this.editableByCurrentSeeker = editableByCurrentSeeker;
		this.expectedSolutions = expectedSolutions;
		this.minimumRequirements = minimumRequirements;
		this.video = video;
		this.attachments = attachments;
		this.challengeAreas = challengeAreas;
		this.submittedDate = submittedDate;
		this.translations = translations;
		this.isExternal = isExternal;
		this.externalLink = externalLink;
		this.externalLogo = externalLogo;
	}
}

export default ChallengeModel;
